import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import ResendActivationStore from './store';
/* stores */

const Index = ({CONFIG, token, orderId}) => {
  const orderResendActivationContext  = useContext(ResendActivationStore);
  const orderResendActivationMethod = async () => {
    orderResendActivationContext.setLoading(true);
    CONFIG.application.order.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.order.api.endpoints.resend_activation.url + orderId + '/resend-email',
      config: {
        method: CONFIG.application.order.api.endpoints.resend_activation.method,
        headers: CONFIG.application.order.api.headers
      }
    });
    orderResendActivationContext.setStatus(fetch[0]);
    orderResendActivationContext.setData(fetch[1]);
    orderResendActivationContext.setLoading(false);
  }
  const orderResendActivationData = orderResendActivationContext.isData();

  return { orderResendActivationContext, orderResendActivationMethod, orderResendActivationData }
}

export default Index;
